import ProductRoutes from "./product";
import GridReportRoutes from "./grid-reports";
import BatchRoutes from "./batch";

export default [
    ...ProductRoutes,
    ...GridReportRoutes,
    ...BatchRoutes
];
